import { render, staticRenderFns } from "./sessionsList.vue?vue&type=template&id=4667c66a&scoped=true"
import script from "./sessionsList.vue?vue&type=script&lang=js"
export * from "./sessionsList.vue?vue&type=script&lang=js"
import style0 from "./sessionsList.vue?vue&type=style&index=0&id=4667c66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667c66a",
  null
  
)

export default component.exports